import React from "react";

const SelectFuncionarios = ({ list, selectedID=null, name, className='form-select', idValue=null, required=false }) => {

    return (
        <select className={className} name={name} id={idValue} required={required}>
            <option value="">Seleccionar...</option>
            {list.map((item, i) => {
                return (
                    <option key={i} value={item.id_officer} selected={item.id_officer == selectedID ? true : false}>{item.officerName}</option>
                )
            })}
        </select>
    );
}

export default SelectFuncionarios;